import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import LabelValue from '../../../../packages/kiti/components/presentation/LabelValue'
import { useStockItem } from '../_load/StockItemLoader'

const Details = () => {
  const { t } = useTranslation('listStocks')
  const stockItem = useStockItem()

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="50%">
        <LabelValue label={t('details.availableAmount')} value={stockItem?.amount} />
      </Col>

      <Col width="50%">
        <LabelValue label={t('details.totalAmount')} value={stockItem?.totalAmount} />
      </Col>

      <Col width="50%">
        <LabelValue
          label={t('details.status')}
          value={stockItem?.enabled ? t('details.status.active') : t('details.status.inactive')}
        />
      </Col>
    </Grid>
  )
}

export default Details
